export default __webpack_public_path__ + "static/media/mentorship.bc7abe8d.png";